import { useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import WorkoutCard from "./WorkoutCard";
import moment from "moment";

function BannerYourDay(props) {
    const navigate = useNavigate();
    const { program, workout, selectedDate } = props;
    const gradient = program?.gradient ? program?.gradient?.split("-") : null;
    const mDate = moment(`${selectedDate?.year}/${selectedDate?.month}/${selectedDate?.day}`);

    return (
        <>
            {
                true
                    ? <div className="ydb-banner" style={{ backgroundColor: `${gradient?.[0]}` }} onClick={() => {
                        if (workout?.id) {
                            navigate(`/workout?workout=${workout?.id}`);
                        }
                    }}>
                        <div className="ydb-banner-description">
                            <h4>Your Day</h4>
                            <p>{mDate?.format('dddd,')} {mDate?.format('MMMM DD')}</p>
                            <p>Est. Time: {Math.floor(workout?.video_time / 60)} mins</p>
                        </div>
                        <div className="ydb-banner-card-wrapper">
                            <WorkoutCard isFavorite={false} video={workout} program={program} />
                        </div>
                    </div>
                    : <div className="ydb-banner" style={{ padding: 0, backgroundColor: "transparent", overflow: "hidden" }}>
                        <Skeleton variant="rectangular" width={"100%"} height={200} />
                    </div>
            }
        </>
    );
}

export default BannerYourDay;